import React, {Component} from "react";
import {Button, Modal, Layout, Icon} from "antd";
import _ from "i18n";
import {connect} from "react-redux";
import { Row, Col } from 'antd';
import {getRecapByDay} from "../../../actions/thunks.js";
import {setFilterInvoicesByDay} from "../../../actions/actions.js";
import {formatAmount} from "utils";
import {map, reduce} from 'lodash';
import moment from "moment";

class RecapByDay extends Component {


  componentDidMount() {
    if(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0) {
      this.props.getRecapByDay(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.operationType ? this.props.operationType : null, this.props.statisticsFilter.appType && this.props.statisticsFilter.appType.length > 0 ? this.props.statisticsFilter.appType : [])
    }
  }


  componentDidUpdate(prevProps, prevState)
  {

    if((prevProps.operationType !== this.props.operationType) && this.props.operationType !== null) {

      this.props.getRecapByDay(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.operationType ? this.props.operationType : null, this.props.statisticsFilter.appType && this.props.statisticsFilter.appType.length > 0 ? this.props.statisticsFilter.appType : [])
    }
  }


  constructBloc = ({amount, day}) => {

    return (
      <div>

        <div className="flex flex-row justify-between">
          <div className={this.props.recapByDay.filterDay == day? "div-day-recap div-day-recap-active":"div-day-recap"} onClick={() => {
          this.setDayFilter(day)}}>
            {moment(day).format("DD/MM/YYYY")}
          </div>
          <div className=" self-end pr-4  div-recap-amount">
            {formatAmount(amount)}
          </div>
        </div>
        <div className="line"/>
      </div>
    )

  }

  calculSum = () => {
    return reduce(this.props.recapByDay.items['jour'], (sum, { amount }) => (sum + parseInt(amount)), 0);
  }


  toggleDayChecked = () => {

    this.props.setFilterInvoicesByDay(null)
  }

  setDayFilter = (day) => {

    this.props.setFilterInvoicesByDay(day)
  }

  render() {

    let {recapByDay} = this.props;

    if(!recapByDay || !recapByDay.items || recapByDay.items.length === 0) {

      return <div>

      </div>
    }

    return (
      <div className="recap-day-container pl-4 pt-6">

        <div className="modal-recap-title">
          Jours
        </div>

        <div className="pt-4 scroll-div-recap w-48">
          { map(recapByDay.items['jour'], this.constructBloc) }

        </div>

        <div className="flex flex-row justify-between pt-4  pr-4 pb-4">
          <div className="border-right-line"> TOTAL</div>
          <div className="div-recap-amount-total"> { formatAmount(this.calculSum()) } </div>
        </div>
      </div>
      );
  }
}

const mapStateToProps = state => ({
  statisticsFilter: state.filters.statisticsFilter,
  recapByDay: state.recapByDay,
});

const mapDispatchToProps = {
  getRecapByDay,
  setFilterInvoicesByDay
};

export default connect(mapStateToProps, mapDispatchToProps)(RecapByDay);



// WEBPACK FOOTER //
// ./app/components/Admin/statisctics/RecapByDay.js